import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.inquiryDetails;
export const inquiryDetailsSelector = (state: RootState) => getState(state).data;
export const inquiryDetailsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const inquiryDetailsErrorSelector = (state: RootState) => getState(state).error;
export const isDietaryInListInInquiryDetailsSelector =
  (dietarySupplementName: string) => (state: RootState) =>
    inquiryDetailsSelector(state)?.supplementInquiriesDto.some(
      supplementInquiry => supplementInquiry.name === dietarySupplementName,
    );
export const isInStatusSelector = (statusId: number) => (state: RootState) =>
  inquiryDetailsSelector(state)?.inquiryStatusId === statusId;
